import React from 'react'
import PropTypes from 'prop-types';
import Checkbox from "components/Checkbox";
import {makeStyles} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";

const useStyle = makeStyles(theme => ({
    wrap: {
        marginLeft: theme.spacing(4)
    }
}));


function SwzGeneratorQuestionCheckbox(
    {
        id,
        question,
        formikProps
    }) {
    const classes = useStyle();

    const changeMain = (e) => {
        const fPName = e.target.name;
        const qKey = fPName.replace(/#/g, '.');
        const opt = question.options.find((x) => x.key === qKey && x.subOptions)
        if(opt) {
            const checked = e.target.checked;
            const sub = opt.subOptions.reduce((prev, curr) => {
                return {
                    ...prev,
                    [curr.key.replace(/\./g, '#')]: checked
                }
            }, {})
            sub[fPName] = checked;
            formikProps.setValues({
                ...formikProps.values,
                ...sub
            })
        }
    }

    const changeSub = (e) => {
        const fPName = e.target.name;
        const qKey = fPName.replace(/#/g, '.');
        const opt = question.options.find((x) => !!x.subOptions && x.subOptions.find(y => y.key === qKey))
        const checked = e.target.checked;
        if(opt) {
            if(checked) {
                formikProps.setFieldValue(opt.key.replace(/\./g, '#'), checked);
            } else {
                const otherChecked = opt.subOptions.find(y => y.key !== qKey && getObjectValue(y.key.replace(/\./g, '#'), formikProps.values, false));
                if(!otherChecked) {
                    formikProps.setFieldValue(opt.key.replace(/\./g, '#'), checked);
                }
            }
        }
    }

    return (question.options.map(x => (
        <div key={x.key}>
            <Checkbox id={x.key.replace(/\./g, '#')} label={x.text} formikProps={formikProps} onChange={changeMain}/>
            <br/>
            {!!x.subOptions ?
                x.subOptions.map(so => (
                    <div className={classes.wrap} key={so.key}>
                        <Checkbox id={so.key.replace(/\./g, '#')} label={so.text} formikProps={formikProps} onChange={changeSub}/>
                    </div>
                )) : null}
        </div>
    )))
}

SwzGeneratorQuestionCheckbox.propTypes = {
    classes: PropTypes.any,
}

export default SwzGeneratorQuestionCheckbox;